// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.cleaning_text_input_mode_enum */
var CleaningTextInputModeEnum;
(function (CleaningTextInputModeEnum) {
    CleaningTextInputModeEnum["FREE_TEXT"] = "FREE_TEXT";
    CleaningTextInputModeEnum["DROPDOWN"] = "DROPDOWN";
    CleaningTextInputModeEnum["AUTOCOMPLETE"] = "AUTOCOMPLETE";
})(CleaningTextInputModeEnum || (CleaningTextInputModeEnum = {}));
;
export default CleaningTextInputModeEnum;
/** Zod schema for cleaning_text_input_mode_enum */
export const cleaningTextInputModeEnum = z.nativeEnum(CleaningTextInputModeEnum);
//# sourceMappingURL=CleaningTextInputModeEnum.js.map